export default __webpack_public_path__ + "static/media/Face.de507d5b.svg";